export default __webpack_public_path__ + "static/media/pdf_image.064f4236.jpeg";